import Box from "@mui/material/Box"
import logo from "../../../../assets/images/logo_smaart_green.png"

export const Logo = ({
  width = "50%",
  height = "auto",
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%"
      }}
      onClick={() => {}}
    >
      <img
        src={logo}
        alt="Brand Logo"
        style={{
          width: typeof width === "number" ? `${width}px` : width,
          height: typeof height === "number" ? `${height}px` : height,
        }}
      />
    </Box>
  )
}
